import { render, staticRenderFns } from "./ReportIssueCreate.vue?vue&type=template&id=bc3f0830&scoped=true&"
import script from "./ReportIssueCreate.vue?vue&type=script&lang=js&"
export * from "./ReportIssueCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3f0830",
  null
  
)

export default component.exports